const CardsData = [
  {
    id: 0,
    title: 'Возьмите обучение под контроль',
    iconName: 'chart',
    description: 'Следите за своим прогрессом с помощью детальной ',
    linkName: 'статистики.',
    path: '/statistics',
  },
  {
    id: 1,
    title: 'Не останавливайтесь',
    iconName: 'bulb',
    description:
      'Более 3500 слов подобранных под каждый уровень подготовки содержится в ',
    linkName: 'учебнике.',
    path: '/textbook',
  },
  {
    id: 2,
    title: 'Бросьте себе вызов',
    iconName: 'puzzle',
    description: `Не заскучать и одновременно укрепить знания помогут `,
    linkName: 'игры.',
    path: '/games',
  },
];

export default CardsData;
